<template>
  <div>
    <div v-if="headers">
      <mds-table :class="[$style['tablesettings']]" fixed-first-col>
        <mds-thead style="z-index: 99; position: sticky">
          <mds-th
            :key="index"
            v-for="(header, index) in headers"
            style="width: 190px"
            :class="$style['headingryt']"
          >
            <div :key="e" v-for="(i, e) in splitData(header)">
              {{ i }}
            </div>
          </mds-th>
        </mds-thead>
        <mds-tbody style="z-index: 5; position: sticky">
          <mds-tr :key="i" v-for="(e, i) in Elements"
          :class="[e.isBold ? $style['textBold'] : '']">
            <mds-td  :class="[
             e.isSubHead  ?  $style['subHeadAlign'] :
             e.rightAlign? $style['rightAlign']:
             e.subRightAlign? $style['subRightAlign']:''
              ]">
              {{ e.name }}
            </mds-td>
            <mds-td
              :key="index"
              style="text-align: right"
              v-for="(r, index) in rows"
              :class="[e.isRed ?  $style['textRedColor'] : '' ]"
            >
              {{
                e.isAmount
                  ? formatCurrency(
                      e.AllowNegative ? r[e.key] : removeNegative(r[e.key])
                    )
                  : e.AllowNegative
                  ? r[e.key]
                  : removeNegative(r[e.key])
              }}
            </mds-td>
          </mds-tr>
        </mds-tbody>
      </mds-table>
    </div>
  </div>
</template>
<script>
import { CommonHelper } from "../../helpers";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table";

export default {
  name: "ChartTable",
  components: { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd },
  props: {
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    Elements: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    splitData(data) {
      return data.toString().split("|");
    },
    formatCurrency(amount) {
      return CommonHelper.convertIntoCurrencyWithoutDecimal(amount);
    },
    removeNegative(data) {
      return data > 0 ? data : 0;
    },
  },
};
</script>
<style lang="scss" module>
@import "@mds/constants";

.mds-table__scroller:focus {
  box-shadow: none;
}
.headingryt:first-child {
  z-index: 999999 !important;
  position: sticky !important;
  .mds-th__inner {
    float: left;
  }
}

.headingryt .mds-th__inner {
  float: right;
}
.headingryt .mds-th__text {
  text-align: right;
}
.wrapperdivtable {
  max-height: 500px;
  overflow: scroll;
}
.tablesettings {
  max-height: 500px;
  overflow-x: none !important;
  overflow-y: scroll;
  th {
    top: 0 !important;
    position: sticky !important;
    z-index: 999;
  }
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #c3d0da;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

th {
  top: 0;
  position: sticky;
}
.rightAlign  {
  padding-left: 10px !important;
}
tr.textBold td{
  font-weight:600 !important;
}
.subHeadAlign {
  padding-left: 35px !important;
}
.subRightAlign {
  padding-left: 20px !important;
}
</style>
